"use client";

import { MarkdownRenderer } from '@/components/ui/markdown-renderer';

type AboutContentProps = {
  content: string;
};

export default function AboutContent({ content }: AboutContentProps) {
  return (
    <div className="mt-6">
      <MarkdownRenderer content={content} />
    </div>
  );
}